import React, { useEffect, useState, useRef, useMemo } from "react";
import Highcharts, { color } from 'highcharts'
import HighchartsMap from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
// import HighchartsMap from 'highcharts/modules/map';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from "primereact/skeleton";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { utils } from "../../../utils/index";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { t } from "i18next";
import '../menu.css'
import { LoginResponse } from "../../../models/index";
import mapData from '../../../constants/CountriesMap.json'

const BotAnalysisReport = () => {
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse
    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [exportloading, setExportLoading] = useState(false)
    const [refreshState, setRefreshState] = useState<any>(new Date())
    const [loadingWebsite, setLoadingWebsite] = useState(true)
    const [hidebutton, setHideButton] = useState(false)
    const [getbotchatstats, setGetbotchatstats] = useState<any[]>([])
    const [getbotchatgraphData, setGetbotchatGraphData] = useState<any[]>([])
    const [mapdata, setMapData] = useState<any>("")

    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }

    useEffect(() => {
        fetchMapData()
        ApiCalls()
    }, [])

    const fetchMapData = async () => {
        setMapData(mapData)

    };
    const ApiCalls = async () => {
        loadWebsites()
    };

    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }

    const ExportPDF = async () => {
        if (!selectedWebsite) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.website-validtion'))
            return;
        }

        setExportLoading(true);
        const element = document.getElementById('botAnalysis-report');
        if (element) {
            const pdf = new jsPDF();
            const sectionIds = ['section1', 'section2'];
            // Dimensions for the logo
            const logoWidth = 100;
            const logoHeight = 36;
            const logoY = 1;
            const logoX = 90;

            for (let i = 0; i < sectionIds.length; i++) {
                const sectionId = sectionIds[i];
                const section = document.getElementById(sectionId);
                let sectionWidth = pdf.internal.pageSize.getWidth();
                let sectionHeight = 120;
                if (sectionId === 'section1') {
                    sectionWidth = pdf.internal.pageSize.getWidth() - 5;
                    sectionHeight = 250;
                } else if (sectionId === 'section2') {
                    sectionWidth = pdf.internal.pageSize.getWidth() - 5;
                    sectionHeight = 70;
                }
                if (i > 0) {
                    pdf.addPage();
                }
                if (section) {
                    const canvas = await html2canvas(section);
                    const imgData = canvas.toDataURL('image/png');
                    pdf.addImage(imgData, 'PNG', 2, 20, sectionWidth, sectionHeight);
                    if (sectionId === 'section1') {
                        const imageElement = document.getElementById('logoImage');
                        const imgDataUrl = imageElement?.getAttribute('src') || '';
                        const canvasLogo = document.createElement('canvas');
                        const ctxLogo = canvasLogo.getContext('2d');

                        if (ctxLogo) {
                            const imgLogo = new Image();
                            imgLogo.src = imgDataUrl;
                            await new Promise(resolve => {
                                imgLogo.onload = () => {
                                    ctxLogo.drawImage(imgLogo, 0, 10, logoWidth, logoHeight);
                                    resolve(null);
                                };
                            });
                            const logoDataUrl = canvasLogo.toDataURL('image/png');
                            pdf.addImage(logoDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
                        }
                    }
                }
            }
            pdf.save('Bot Analysis Report.pdf');
        }
        setExportLoading(false);
    };

    const submit = () => {
        if (!selectedWebsite) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.website-validtion'))
            return;
        }
        else {
            setLoading(true)
            BotAnalysisAPi()
        }
    }
    const loadWebsites = async () => {
        let response = await wglcsApiService.getwebsitesbyempCompany(userData?.userLoginData?.empCompId.toString());
        var sortedData = utils.arraySorting('domainName', response?.data?.data)
        setWebsiteArray(sortedData)
        setLoadingWebsite(false)
    };
    const WebsiteOptionTemplate = (option) => {
        if (loadingWebsite) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.domainName}</div>
                </div>
            );
        }
    };
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
    }
    const BotAnalysisAPi = async () => {
        var params = {
            fromDate: moment(fromDate).format("YYYY-MM-DD").toString(),
            toDate: moment(toDate).format("YYYY-MM-DD").toString(),
            websiteId: selectedWebsite.websiteId
        };
        const [botChatStats, botChatGraphData] = await Promise.all([
            wglcsApiService.getbotchatslocationwisestats(params),
            wglcsApiService.getbotchatslocationwisev1(params)
        ]);
        const chatStatsData = botChatStats?.data?.data || [];
        const chatGraphData = botChatGraphData?.data?.data || [];
        setGetbotchatstats(chatStatsData);
        setGetbotchatGraphData(chatGraphData);
        setLoading(false)
    }


    const renderLoader = () => {
        return (
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px", marginTop: "2px" }} animationDuration=".5s" />
      
        );
    }


    const formatTimeToAMPM = (timeString) => {
        const date = new Date(timeString);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + ampm;
        return formattedTime;
    };


    const processUserrEngagementData = () => {
        const chatsByHour = {};

        getbotchatgraphData?.forEach((entry) => {
            const chatTime = formatTimeToAMPM(entry.chatstarttime);
            if (!chatsByHour[chatTime]) {
                chatsByHour[chatTime] = 0;
            }
            chatsByHour[chatTime] += entry.totalChat;
        });
        const arrangedData = arrangeData(chatsByHour);
        const sortedData = sortTimeData(arrangedData);
        return sortedData;
    };

    const arrangeData = (data) => {
        return Object.keys(data).map(time => ({
            time: time,
            totalChats: data[time]
        }));
    };
    const sortTimeData = (data) => {
        return data.sort((a, b) => {
            // Split the time and period (AM/PM)
            const [timeA, periodA] = a.time.split(" ");
            const [timeB, periodB] = b.time.split(" ");
            // Sort by PM first, then AM
            if (periodA !== periodB) {
                return periodA === "PM" ? -1 : 1; // PM should come first
            }

            // If both are in the same period (AM or PM), compare times
            const [hourA, minuteA] = timeA.split(":").map(Number);
            const [hourB, minuteB] = timeB.split(":").map(Number);

            // Handle 12:00 separately since 12:00 AM/PM is a special case
            const normalizedHourA = hourA === 12 ? 0 : hourA;
            const normalizedHourB = hourB === 12 ? 0 : hourB;

            // Compare hours, then minutes if hours are equal
            if (normalizedHourA !== normalizedHourB) {
                return normalizedHourA - normalizedHourB;
            }
            return minuteA - minuteB;
        });
    };

    // Execute the process to get the sorted engagement data
    const sortedUserEngagementData = processUserrEngagementData();
    const userEngagement = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.UserEngagement'),
            align: 'left',
            style: {
                fontSize: '14px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000", fontWeight: 400
            }
        },
        xAxis: {
            title: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                step: 1, // Show all labels
                rotation: -45, // Rotate labels to avoid overlap
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
            categories: sortedUserEngagementData.map(m => m.time),
            accessibility: {
                description: 'Countries'
            }
        },
        yAxis: {
            title: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}',
                    style: {
                        fontSize: '8px' // Adjust the font size here
                    }
                }
            },
            column: {
                pointPadding: 0.25,
                borderWidth: 0
            }
        },
        series: [
            {
                name: t('StaticReport-Text.Time'),
                data: sortedUserEngagementData.map(m => m.totalChats)
            }
        ]
    }
    const renameAcquisitionChannels = () => {
        return getbotchatgraphData.map(chat => {
            let renamedChannel = chat.acquisitionChannels;
            switch (chat.acquisitionChannels) {
                case "Google":
                    renamedChannel = "Google";
                    break;
                case "Bing":
                    renamedChannel = "Bing";
                    break;
                case "Facebook":
                    renamedChannel = "Facebook";
                    break;
                case "Yahoo":
                    renamedChannel = "Yahoo";
                    break;
                default:
                    renamedChannel = chat.acquisitionChannels; // Keep as-is for other values
                    break;
            }

            return {
                ...chat,
                acquisitionChannels: renamedChannel
            };
        });
    };
    // Transform the data by renaming the channels
    const TransformData = renameAcquisitionChannels();
    // Prepare data for each acquisition channel
    const acquisitionData = TransformData.reduce((acc, curr) => {
        const channel = curr.acquisitionChannels;
        if (!acc[channel]) {
            acc[channel] = 0;
        }
        acc[channel] += curr.totalChat;
        return acc;
    }, {});
    // Convert the acquisitionData object into series format for Highcharts
    const acquisitionseriesData = Object.keys(acquisitionData).map(channel => ({
        name: channel, // The channel name (Google, Organic, etc.)
        data: [acquisitionData[channel]] // Sum of total chats for each channel
    }));

    const AcquisitionChannels = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.AcquisitionChannels'),
            align: 'left',
            style: {
                fontSize: '14px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: [""]
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.35,
                borderWidth: 0
            }
        },
        series: acquisitionseriesData
    }

    const PeakUsageTime = getbotchatgraphData?.map(item => {
        const timestamp = new Date(item.chatstarttime).getTime(); // Convert to timestamp
        return [timestamp, item.totalChat]; // Return the array in the format [timestamp, totalChat]
    });

    const formattedData = PeakUsageTime.map(([timestamp, value]) => {
        return {
            x: timestamp, // Timestamp for the x-axis (time)
            y: value      // Total chats for the y-axis
        };
    });

    const yValues = PeakUsageTime.map(data => data[1]);
    function generateTicks(data, step) {
        const maxValue = Math.max(...data); // Get the maximum value from data
        const maxTick = Math.ceil(maxValue / step) * step + step; // Round the max value up to the nearest multiple of the interval

        let ticks: any = [];
        for (let i = 0; i <= maxTick; i += step) {
            ticks.push(i);
        }
        return ticks;
    }
    const PeakUsageTime_Graph = {
        chart: {
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0',
            type: 'spline',
            scrollablePlotArea: {
                scrollPositionX: 1
            }
        },
        title: {
            text: t('GraphReports-label.PeakUsageTime'),
            align: 'left',
            style: {
                fontSize: '14px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        rangeSelector: {
            selected: 1
        },
        xAxis: {
            labels: {
                enabled: false // Hide x-axis labels
            },
            title: {
                text: null,
            }
        },
        yAxis: {
            tickPositions: generateTicks(yValues, 1),  // Custom tick positions  
            title: {
                text: 'Total Chats',
            }
        },
        tooltip: {
            shared: true, // Shows values from all series in the tooltip
            formatter: function (this: any) {
                // Custom tooltip content
                const point = this.points[0]; // Assuming you have a single series
                const customData = point.x; // Use point.x for the timestamp or custom value
                const totalChat = point.y; // Use point.y for the total chat count

                return `<b>Time: ${new Date(customData).toLocaleString()}</b><br/>
                        Total Chats: ${totalChat}`;
            }
        },
        series: [{
            name: '',
            data: formattedData.map(m => m.y),
            type: 'area',
            lineWidth: 2,  // Line width for the line graph
            color: {
                linearGradient: {
                    x1: 0,
                    x2: 0,
                    y1: 0,
                    y2: 2  // Vertical gradient (top to bottom)
                },
                stops: [
                    [0, 'rgb(44, 175, 254)'], // Top color for gradient (blue)
                    [1, utils.isDarkMode() ? '#00000000' : '#f0f0f000'] // Transparent bottom
                ]
            },
            fillOpacity: 0.4,  // Adjust the opacity for the gradient area           
            threshold: null,  // Show the area below the line
            tooltip: {
                valueDecimals: 2
            }
        }]
    }

    const donutChartmobileValue = getbotchatstats[0]?.mobile
    const donutChartdesktopValue = getbotchatstats[0]?.desktop;
    const donutGraph = {
        chart: {
            type: 'pie',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        title: {
            text: t('GraphReports-label.Device'),
            align: 'left',
            style: {
                fontSize: '14px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 3,
                dataLabels: [{
                    enabled: true,
                    distance: 10,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -20,
                    format: '{point.y}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
            colorByPoint: true,
            innerSize: '60%',
            data: [{
                name: 'Mobile Phones',
                y: donutChartmobileValue,
                // color: '#4e86c7'
            }, {
                name: 'Web',
                y: donutChartdesktopValue
            }]
        }]
    }

    // Group by country and sum total chats
    const groupedData = getbotchatgraphData?.reduce((acc, { country, totalUsers }) => {
        if (!acc[country]) {
            acc[country] = 0; // Initialize the total if country does not exist
        }
        acc[country] += totalUsers; // Sum up the total chats for the country
        return acc;
    }, {});

    // Create a mapping for country names
    const countryNameMap = {
        "United States": "United States of America",
        // Add other mappings if needed
    };

    // Convert grouped data to the format needed for the map
    const seriesData = Object.keys(groupedData).reduce((acc: any, country) => {
        // Check if the country exists in the map data
        const mappedCountry = countryNameMap[country] || country;
        const mapEntry = mapdata.objects.default.geometries.find(geometry => geometry.properties.name.toLowerCase()
            .includes(mappedCountry.toLowerCase())); // Adjust as necessary to match your map data keys
        if (mapEntry) {
            acc.push({
                isoA3: mapEntry.properties['iso-a3'],
                name: mapEntry.properties.name,
                value: groupedData[country],
                code: country
            });
        }
        return acc;
    }, []);




    const options = {
        chart: {
            map: mapdata,
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.UserLocation'),
            align: 'left',
            style: {
                fontSize: '14px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        credits: {
            enabled: false
        },
        mapNavigation: {
            enabled: true,
            buttonOptions: {
                verticalAlign: 'bottom'
            }
        },
        colorAxis: {
            min: 0,
            minColor: '#023e8a',
            maxColor: '#0077b6',
        },
        tooltip: {
            pointFormat: '{point.code}: {point.value} Users'
        },
        series: [{
            name: 'Total Users',
            joinBy: ['iso-a3', 'isoA3'], // Join by ISO alpha-3 code
            data: seriesData,
            states: {
                hover: {
                    // border:"#ade8f4",
                    //   color: '#BDC2D1'
                }
            },
            dataLabels: {
                enabled: true,
                format: '{point.isoA3}' // Display full country name on the map
            }
        }]
    };
    return (
        <div >
            <div className="row p-2">
                <img id="logoImage" style={{ display: "none" }} src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" />
                <div className="wgreport-tab viewreport-box">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="basic">{t('Resource Pool.Websites')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="domainName"
                                value={selectedWebsite}
                                options={WebsiteArray}
                                onChange={onWebsiteChange}
                                optionLabel="domainName"
                                itemTemplate={WebsiteOptionTemplate}
                                placeholder={!loadingWebsite ? t('ReportComponent.Select Website') : selectedWebsite}
                            />
                            {loadingWebsite && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                maxDate={new Date()}
                                minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                            />
                        </div>

                        <div className="col-lg-3 py-1 text-right text-lg-left">
                            {hidebutton == false ? <>   <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple export-pdf-btn" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                <ProgressSpinner
                                    style={{ width: "25px", bottom: "10px" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /> : t('wg-buttons.Export-PDF')}</button>
                            </> : ""}
                            <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="botAnalysis-report" >
                {loading == true ?
                    <div style={{ textAlign: "center", marginTop: "20%" }}>
                        <ProgressSpinner
                            style={{ width: "50px", position: "relative" }}
                            strokeWidth="3"
                            fill="#EEEEEE"
                            animationDuration=".5s"
                        />
                    </div>
                    : (<>
                        <div id="section1" >
                            <div className="row">
                                <div className="col-md-6 wgreport-tab">
                                    <div className="card" style={{ width: "100%", padding: 5, height: getbotchatgraphData.length != 0 ? "auto" : "370px" }}>
                                        {getbotchatgraphData.length != 0 ? <>
                                            <HighchartsReact
                                                highcharts={HighchartsMap}
                                                constructorType={'mapChart'}
                                                options={options}
                                            />
                                        </> : <div style={{ marginTop: "8px", backgroundColor: utils.isDarkMode() ? "#000000" : 'white', height: "350px" }}>
                                            <h6 style={{ position: "relative", textAlign: "left", left: "2%", top: "2%" }} className="wgreport_heading">{t('GraphReports-label.UserLocation')}</h6>
                                            <h6 style={{ position: "relative", top: "45%" }} className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>
                                        </div>}
                                    </div>
                                </div>
                                <div className="col-md-6 wgreport-tab">
                                    <div className="card" style={{ width: "100%", padding: 5, height: getbotchatgraphData.length != 0 ? "auto" : "370px" }}>
                                        {getbotchatgraphData.length != 0 ? <>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={donutGraph}
                                            />
                                        </> : <div style={{ marginTop: "8px", backgroundColor: utils.isDarkMode() ? "#000000" : 'white', height: "350px" }}>
                                            <h6 style={{ position: "relative", textAlign: "left", left: "2%", top: "2%" }} className="wgreport_heading">{t('GraphReports-label.Device')}</h6>
                                            <h6 style={{ position: "relative", top: "45%" }} className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 wgreport-tab">
                                    <div className="card" style={{ width: "100%", padding: 5, height: getbotchatgraphData.length != 0 ? "auto" : "370px" }}>
                                        {getbotchatgraphData.length != 0 ? <>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={userEngagement}
                                            />
                                        </> : <div style={{ marginTop: "8px", backgroundColor: utils.isDarkMode() ? "#000000" : 'white', height: "350px" }}>
                                            <h6 style={{ position: "relative", textAlign: "left", left: "2%", top: "2%" }} className="wgreport_heading">{t('GraphReports-label.UserEngagement')}</h6>
                                            <h6 style={{ position: "relative", top: "45%" }} className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 wgreport-tab">
                                    <div className="card" style={{ width: "100%", padding: 5, height: getbotchatgraphData.length != 0 ? "auto" : "370px" }}>
                                        {getbotchatgraphData.length != 0 ? <>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={AcquisitionChannels}
                                            />
                                        </> : <div style={{ marginTop: "8px", backgroundColor: utils.isDarkMode() ? "#000000" : 'white', height: "350px" }}>
                                            <h6 style={{ position: "relative", textAlign: "left", left: "2%", top: "2%" }} className="wgreport_heading">{t('GraphReports-label.AcquisitionChannels')}</h6>
                                            <h6 style={{ position: "relative", top: "45%" }} className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>
                                        </div>}
                                    </div>

                                </div>
                                <div className="col-md-6 wgreport-tab">
                                    <div className="card" style={{ width: "100%", padding: 5, height: getbotchatgraphData.length != 0 ? "auto" : "370px" }}>
                                        {getbotchatgraphData.length != 0 ? <>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={PeakUsageTime_Graph}
                                            />
                                        </> : <div style={{ marginTop: "8px", backgroundColor: utils.isDarkMode() ? "#000000" : 'white', height: "350px" }}>
                                            <h6 style={{ position: "relative", textAlign: "left", left: "2%", top: "2%" }} className="wgreport_heading">{t('GraphReports-label.PeakUsageTime')}</h6>
                                            <h6 style={{ position: "relative", top: "45%" }} className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="section2">
                            <div className="row px-1">
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/chat.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0] ? getbotchatstats[0]?.totalChat ?? 0 : 0}</label>
                                    <span>{t('ReportComponent.Total Chats')}</span>
                                </div>
                                <div className="col  botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/response-time.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0] ? getbotchatstats[0]?.responseTime ?? 0 : 0}
                                        <sub style={{ paddingLeft: "2px" }}>Sec</sub>
                                    </label>
                                    <span>{t('GraphReports-label.Response-Time')}</span>
                                </div>
                                <div className="col  botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/duration.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0] ? getbotchatstats[0]?.averageBotDurationMin ?? 0 : 0}
                                        <sub style={{ paddingLeft: "2px" }}>Min</sub>
                                    </label>
                                    <span>{t('ReportComponent.Chat Duration')}</span>
                                </div>
                                <div className="col  botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/visitor.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0] ? getbotchatstats[0]?.nameProvided ?? 0 : 0}</label>
                                    <span>{t('GraphReports-label.Visitor-nameprovided')}</span>
                                </div>
                                <div className="col  botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/chat.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.chattoLeads ?? 0}</label>
                                    <span>{t('GraphReports-label.Chat-leads')}</span>
                                </div>
                            </div>
                            <div className="row px-1">
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/chat.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.bottoAgentChats ?? 0}</label>
                                    <span>{t('GraphReports-label.Bot-AgentChatsTransfer')}</span>
                                </div>
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/completion.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.["ChatCompletionRate(CCR)"] === null ? 0 : getbotchatstats[0]?.["ChatCompletionRate(CCR)"] ?? 0}%</label>
                                    <span>{t('GraphReports-label.ChatCompletion-Rate')}</span>
                                </div>
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/failure.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.failureRate ?? 0}%</label>
                                    <span>{t('GraphReports-label.Failure-Rate')}</span>
                                </div>
                            </div>
                            <div className="row px-1">
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/info.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.contactsProvidedtoBot ?? 0}</label>
                                    <span>{t('GraphReports-label.Visitor-InformationSharedBot')}</span>
                                </div>
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/engagement.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.engagement ?? 0}%</label>
                                    <span>{t('GraphReports-label.Bot-Engagement')}</span>
                                </div>
                                <div className="col botReport-box">
                                    <div className="botimg-div">
                                        <img className="wgreport-boticon" src={process.env.PUBLIC_URL + "/icons_svgs/info.svg"} alt="" />
                                    </div>
                                    <label>{getbotchatstats[0]?.contactsProvidedtoAgent ?? 0}</label>
                                    <span>{t('GraphReports-label.Contact-SharedAgents')}</span>
                                </div>
                            </div>
                        </div>
                    </>)
                }
            </div>

        </div >
    )
}
export default BotAnalysisReport;